import React from 'react';

import { useGetLibraryConstantsDictionary } from '../../../hooks/use-get-library-constants-dictionary';
import { ILibraryOpeningHours } from '@/lib/fragments/libraryOpeningHours';
import { ILibraryOpeningHoursException } from '@/lib/fragments/libraryOpeningHoursException';
import { OpeningHours } from '@/components/opening-hours/opening-hours';
import { useGetLibraryConstantsDictionaryData } from '@/providers/ConfigProvider';

export interface MeetingPlaceOpeningHoursBlockProps {
  node_locale: string;
  meetingPlaceOpeningHours?: {
    openingHours?: ILibraryOpeningHours;
    openingHoursExceptions?: ILibraryOpeningHoursException[];
    timezone?: string;
  };
}
const MeetingPlaceOpeningHoursBlock = ({
  node_locale,
  meetingPlaceOpeningHours,
}: MeetingPlaceOpeningHoursBlockProps) => {
  // const dictionary = useGetLibraryConstantsDictionaryData();
  const dictionary = useGetLibraryConstantsDictionaryData();

  return (
    <>
      {meetingPlaceOpeningHours && meetingPlaceOpeningHours?.openingHours && (
        <OpeningHours
          node_locale={node_locale}
          openingHours={meetingPlaceOpeningHours?.openingHours}
          variant="block-compact-exceptions"
          openingHoursClosed={dictionary?.openingHoursClosed ?? ''}
          openingHoursClosedToday={dictionary?.openingHoursClosedToday ?? ''}
          openingHoursExceptions={
            meetingPlaceOpeningHours?.openingHoursExceptions ?? []
          }
          openingHoursOpenToday={dictionary?.openingHoursOpenToday ?? ''}
          timezone={meetingPlaceOpeningHours?.timezone ?? ''}
          openingHoursBlockExceptionTitle={
            dictionary?.openingHoursBlockExceptionTitle
          }
        />
      )}
    </>
  );
};

export default MeetingPlaceOpeningHoursBlock;

// export const query = graphql`
//   fragment BlockMeetingPlaceOpeningHours on ContentfulBlockMeetingPlaceOpeningHours {
//     blocktype: __typename
//     id
//     node_locale
//   }
// `;
